import { Injectable } from "@angular/core";
import { UserBridgeApi } from "./user-bridge.api";
import { map, Observable } from "rxjs";
import { TransferProfileRequest, TransferProfileResponse, UserShortInfo } from "./user-bridge.types";

@Injectable({ providedIn: "root" })
export class UserBridgeService {
  constructor(private userBridgeApi: UserBridgeApi) {}

  getUserShortInfo(authToken: string): Observable<UserShortInfo> {
    return this.userBridgeApi.getUserShortInfo(authToken).pipe(
      map((dto) => ({
        accountId: dto.accountId,
        name: `${dto.firstName} ${dto.lastName}`.trim(),
        email: dto.email,
      })),
    );
  }

  transferProfile(token: string, request: TransferProfileRequest): Observable<TransferProfileResponse> {
    return this.userBridgeApi.transferProfile(token, request).pipe(
      map((dto) => ({
        accountId: dto.accountId,
        success: dto.success,
        authToken: dto.authToken,
        oldPassword: dto.password,
      })),
    );
  }
}
